import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BodyIntro() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Guard: if face step wasn't completed, restart from the beginning
    if (!localStorage.getItem('face_attraction') && localStorage.getItem('swipe_test_done') !== 'true') {
      navigate('/onboarding/swipe-faces', { replace: true });
      return;
    }
    const fadeTimer = setTimeout(() => setVisible(true), 100);
    const navTimer  = setTimeout(() => navigate('/onboarding/swipe-bodies'), 2000);
    return () => { clearTimeout(fadeTimer); clearTimeout(navTimer); };
  }, [navigate]);

  return (
    <div style={{
      height: '100vh', background: '#000',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      opacity: visible ? 1 : 0, transition: 'opacity 0.6s ease',
    }}>
      <div style={{ width: 40, height: 1, background: '#c9a84c', marginBottom: 32 }} />
      <div style={{
        fontFamily: 'var(--font-display)',
        fontSize: 28, fontWeight: 300, color: '#fff', marginBottom: 12,
      }}>
        Now, body type.
      </div>
      <div style={{
        fontFamily: 'var(--font-display)',
        fontStyle: 'italic', fontSize: 14,
        color: 'rgba(255,255,255,0.4)',
      }}>
        Same question. Different signal.
      </div>
    </div>
  );
}
